import React, { Fragment } from 'react';
import SubHeader from 'components/general/SubHeader/SubHeader';
import Select from 'components/forms/Select';
import RiskBarGrid, {
  RiskBarGridPropDef,
} from 'components/charts/RiskBar/RiskBarGrid';

const RiskRatings: React.SFC<RiskRatingsPropDef> = ({
  items,
  riskRatings,
  selectedRisk,
  setActive,
}) => {
  const renderSelect = () => (
    <Select
      options={riskRatings}
      value={selectedRisk}
      onChange={setActive}
    />
  );

  return (
    <Fragment>
      <SubHeader
        title="Your ratings"
        renderAction={renderSelect}
      />
      <RiskBarGrid items={items} />
    </Fragment>
  );
};

RiskRatings.defaultProps = {
  items: [],
  riskRatings: [],
};

interface RiskRatingsPropDef extends RiskBarGridPropDef {
  selectedRisk?: string|number;
  setActive?();
  riskRatings: {
    label: string;
    value: string|number;
  }[];
}

export default RiskRatings;
